// Client subscription for the matcher inbox. The server matcher writes
// into pop_market_matches/{ownerHandle}/incoming/{matchId} whenever a
// counterparty (seller or buyer) shows up whose stock/need aligns with
// yours. This module lets the dashboard render those in real time.

import {
  collection, query, orderBy, limit, onSnapshot,
  doc, updateDoc, serverTimestamp,
} from "firebase/firestore";
import { db } from "../firebase";

const MATCHES_COL = "pop_market_matches";
const PAGE_SIZE = 20;

// Subscribe to fresh matches for a handle. Returns unsubscribe fn.
// `cb` receives an array of match docs sorted newest-first. Empty array
// on error so the caller can still render an empty state.
export function subscribeMatches(handle, cb) {
  if (!handle) { cb([]); return () => {}; }
  const q = query(
      collection(db, MATCHES_COL, handle, "incoming"),
      orderBy("createdAt", "desc"),
      limit(PAGE_SIZE),
  );
  return onSnapshot(q,
      (snap) => cb(snap.docs.map((d) => ({ id: d.id, ...d.data() }))),
      (err) => {
        console.warn("[pop-market] subscribeMatches failed", err);
        cb([]);
      },
  );
}

// Mark a match as seen. Rules only allow flipping `seen` and `seenAt`.
export async function markMatchSeen(handle, matchId) {
  if (!handle || !matchId) return;
  try {
    await updateDoc(doc(db, MATCHES_COL, handle, "incoming", matchId), {
      seen: true,
      seenAt: serverTimestamp(),
    });
  } catch (e) {
    console.warn("[pop-market] markMatchSeen failed", e);
  }
}
